import {useMemo} from 'react'
import clsx from 'clsx'
import {ProductSize} from '~/gql/graphql'
import {useTranslations} from 'use-intl'

type SizeTableProps = {
    className?: string
    sizes: ProductSize[]
    selectedSize?: ProductSize
}

const SizeTable = ({className, sizes, selectedSize}: SizeTableProps) => {
    const t = useTranslations('productDetails.sizeDialog')
    const measureNames = useMemo(
        () => sizes[0].measures?.map((measure) => measure?.name ?? ''),
        [sizes]
    )
    const sprdUnit = useMemo<string>(() => sizes[0].measures?.[0]?.value?.unit ?? 'mm', [sizes])

    if (!measureNames?.length) {
        return null
    }

    return (
        <div className={clsx(className, 'border border-white rounded-lg')}>
            <table className="w-full text-center">
                <thead>
                    <tr>
                        <th scope="col">{t('tableHead')}</th>
                        {measureNames.map((name) => (
                            <th scope="col" key={name} className="px-2 py-1">
                                {name} ({sprdUnit === 'mm' ? 'cm' : 'inch'})
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sizes.map((size) => (
                        <tr
                            key={size.id!}
                            className={clsx(size.id === selectedSize?.id && 'text-green-600')}
                        >
                            <td scope="row" className="px-2 py-1 border-t border-white/50">{size.name}</td>
                            {size.measures?.map((measure) => {
                                const baseValue = measure?.value?.value ?? 0
                                const beautifiedValue =
                                    sprdUnit === 'mm' ? baseValue / 10 : baseValue

                                return (
                                    <td
                                        key={measure?.name}
                                        className="px-2 py-1 border-t border-white/50"
                                    >
                                        {beautifiedValue.toFixed(1)}
                                    </td>
                                )
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SizeTable
